// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-container {
    width: 50px;
    height: 50px;
    background-color: #ececec;
    color: #9d9d9d;
    font-size: 24px;
    text-align: center;
    line-height: 50px;
    border-radius: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/Logo/Logo.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB","sourcesContent":[".logo-container {\n    width: 50px;\n    height: 50px;\n    background-color: #ececec;\n    color: #9d9d9d;\n    font-size: 24px;\n    text-align: center;\n    line-height: 50px;\n    border-radius: 18px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
